import React from "react";
import "../../../assets/styles/customer/layout/home.css";
import HeroSection from "../../../subscreens/customer/heroSection/HeroSection"; // ✅ lowercase
import ProblemSection from "../../../subscreens/customer/problemSection/ProblemSection";
import FeaturesSection from "../../../subscreens/customer/featuresSection/FeaturesSection";
import HowItWorksSection from "../../../subscreens/customer/howItWorksSection/HowItWorksSection";
import StatsSection from "../../../subscreens/customer/statsSection/StatsSection";
import TopDistributorsSection from "../../../subscreens/customer/topDistributorsSection/TopDistributorsSection";
// import AppDownloadSection from "../../../subscreens/customer/appDownloadSection/AppDownloadSection";
// import PricingSection from "../../../subscreens/customer/pricingSection/PricingSection";
import WhyChooseSection from "../../../subscreens/customer/whyChooseSection/WhyChooseSection";
import TestimonialsSection from "../../../subscreens/customer/testimonialsSection/TestimonialsSection";
import CTASection from "../../../subscreens/customer/ctaSection/CTASection";
import MyLayout from "../../../layouts/customer/MyLayout";

const Home = () => {
  return (
    // <>
    <MyLayout>
      <HeroSection />
      <ProblemSection />
      <FeaturesSection />
      <HowItWorksSection />
      <StatsSection />
      <TopDistributorsSection />
      {/* <AppDownloadSection /> */}
      {/* <PricingSection /> */}
      <WhyChooseSection />
      <TestimonialsSection />
      <CTASection />
      </MyLayout>
    // </>
  );
};

export default Home;